<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <EditorComponent :html="data['text']" for-reference @done="c => update(c)" />
    </v-layout>
  </v-container>
</template>

<script>
import EditorComponent from '@/components/editor/EditorComponent';
import Vue from 'vue';

export default {
  name: 'AddReference',
  components: { EditorComponent },
  props: ['data'],
  methods: {
    update(e) {
      Vue.set(this.data, 'text', e);
    }
  }
};
</script>

<style scoped></style>
